module.exports = __webpack_public_path__ + "img/JohnWalker.3e6a37d3.png";